// Vendor libraries
import { CommonModule } from '@angular/common';
// Modules
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class HelpModalModule {
}
HelpModalModule.ɵfac = function HelpModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HelpModalModule)(); };
HelpModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HelpModalModule });
HelpModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ModalBaseModule] });
